const ERROR = 'error';
const NOT_FOUND = 'not_found';
const SUCCESS_NO_CHANGE = 'success_no_change';
const SUCCESS_PRICE_DOWN = 'success_price_down';
const SUCCESS_PRICE_UP = 'success_price_up';
const SUCCESS_UNAVAILABLE = 'success_unavailable';
const TEN_MINUTES_IN_MS = 10 * 60 * 1000;
const LIVECHECK_TTL_IN_MS = TEN_MINUTES_IN_MS;

const EXTERNAL_CONSTANTS = {
    ERROR,
    NOT_FOUND,
    SUCCESS_NO_CHANGE,
    SUCCESS_PRICE_DOWN,
    SUCCESS_PRICE_UP,
    SUCCESS_UNAVAILABLE,
};

export {
    ERROR,
    EXTERNAL_CONSTANTS,
    LIVECHECK_TTL_IN_MS,
    NOT_FOUND,
    SUCCESS_NO_CHANGE,
    SUCCESS_PRICE_DOWN,
    SUCCESS_PRICE_UP,
    SUCCESS_UNAVAILABLE,
};
